import kamala from '../../kamala'
import Cascade from './Cascade'

Cascade.install = function (Vue) {
  kamala(Vue)
  Vue.component(Cascade.name, Cascade)
}

export default Cascade
